export default "/images/bc7fc385c295d0260b9c5cd925ef05bb.png";